import { render, staticRenderFns } from "./AddPatient.vue?vue&type=template&id=3adfd8ba&scoped=true"
import script from "./AddPatient.vue?vue&type=script&lang=js"
export * from "./AddPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adfd8ba",
  null
  
)

export default component.exports